"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metric = {
    overlayName: "metric",
    buttonDisplay: "cm",
    selectOption: {
        label: "Metric (cm / m)",
        value: "m",
    },
};
exports.imperial = {
    overlayName: "imperial",
    buttonDisplay: "in",
    selectOption: {
        label: "Imperial (in / ft)",
        value: "i",
    },
};
exports.AllMeasurements = [exports.metric, exports.imperial];
